import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { authModule, alert } from '@/store'
import { éLoginPorEmail, normalizarEmail } from '../../common/shareds/sharedEmail'
import { obrigatorio } from '@/shareds/regras'
import ContainerCenter from '@/components/ui/ContainerCenter.vue'
import { analytics } from '@/firebase'
import Logo from '@/components/ui/Logo.vue'
import { useRoute, useRouter } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const form = ref<HTMLFormElement & {
	validate: () => boolean,
}>()

const verSenha = ref(false)

const registro = ref({
	// vindo da confirmação do e-mail, o login já chega preenchido
	login: typeof route.query.email === 'string' ? route.query.email : '',
	senha: '',
})

const carregando = ref(false)

const loginDeVisitante = computed({
	get: () => route.query.visitante === null,
	set: (valor: boolean) => {
		router.push({
			name: route.name || undefined,
			query: { visitante: valor ? null : undefined },
		})
	},
})

function prosseguir() {
	router.push({ name: authModule.emailPendente || authModule.sugerirEmail ? 'associar-email' : 'home' })
		.catch(() => {})
}

async function logar() {
	if (!form.value!.validate()) return

	try {
		carregando.value = true
		const { senha } = registro.value
		const login = String(registro.value.login).trim()
		if (loginDeVisitante.value)
			await authModule.logar({ login: 'Visitante', senha })
		else if (éLoginPorEmail(login))
			await authModule.logarPeloEmail(normalizarEmail(login), senha)
		else
			await authModule.logarPeloCim({ cim: login, senha })
		prosseguir()
	} catch (error) {
		alert.setError(error)
	} finally {
		carregando.value = false
	}
}

analytics.logEvent('login', prosseguir)

return { __sfc: true,router, route, form, verSenha, registro, carregando, loginDeVisitante, prosseguir, logar, obrigatorio, ContainerCenter, Logo }
}

})